__turbopack_context__.v({
  "body": "GiveawayModal-module-scss-module__0pg2Za__body",
  "contentHeading": "GiveawayModal-module-scss-module__0pg2Za__contentHeading",
  "details": "GiveawayModal-module-scss-module__0pg2Za__details",
  "header": "GiveawayModal-module-scss-module__0pg2Za__header",
  "heading": "GiveawayModal-module-scss-module__0pg2Za__heading",
  "headingFancy": "GiveawayModal-module-scss-module__0pg2Za__headingFancy",
  "modal": "GiveawayModal-module-scss-module__0pg2Za__modal",
  "modalButtons": "GiveawayModal-module-scss-module__0pg2Za__modalButtons",
  "nonPersistent": "GiveawayModal-module-scss-module__0pg2Za__nonPersistent",
  "smallButton": "GiveawayModal-module-scss-module__0pg2Za__smallButton",
  "splash": "GiveawayModal-module-scss-module__0pg2Za__splash",
  "splashBody": "GiveawayModal-module-scss-module__0pg2Za__splashBody",
  "splashHeading": "GiveawayModal-module-scss-module__0pg2Za__splashHeading",
  "splashImage": "GiveawayModal-module-scss-module__0pg2Za__splashImage",
  "splashSubtitle": "GiveawayModal-module-scss-module__0pg2Za__splashSubtitle",
  "splashTitle": "GiveawayModal-module-scss-module__0pg2Za__splashTitle",
});
